$(document).ready(function () {
	var newDate = getEventDate(new Date(), parseFloat($('meta[name=timezone]').attr('content'))*60);
	newDate.setDate(newDate.getDate());

	setInterval( function() {
		var hours    = getEventDate(new Date(), parseFloat($('meta[name=timezone]').attr('content'))*60).getHours();
		var seconds  = getEventDate(new Date(), parseFloat($('meta[name=timezone]').attr('content'))*60).getSeconds();
		var minutes  = getEventDate(new Date(), parseFloat($('meta[name=timezone]').attr('content'))*60).getMinutes();

		// var realTime = ( hours < 10 ? '0' : '' ) + hours + ' : ' + ( minutes < 10 ? '0' : '' ) + minutes + ' : ' + ( seconds < 10 ? '0' : '' ) + seconds
		var realTime = ( hours < 10 ? '0' : '' ) + hours + ' : ' + ( minutes < 10 ? '0' : '' ) + minutes;
		var realTime2 = ( hours < 10 ? '0' : '' ) + hours + ':' + ( minutes < 10 ? '0' : '' ) + minutes;

		$('.hours-time').html(realTime);
		$('[data-hours-time]').html(realTime2);
		$('.hours-time').attr('data-time', realTime);

	}, 1000);
});


// Javascript is used to set the clock to your computer time.
var currentSec = getSecondsToday();
var seconds = (currentSec / 60) % 1;
var minutes = (currentSec / 3600) % 1;
var hours = (currentSec / 43200) % 1;

setTime(60 * seconds, "second");
setTime(3600 * minutes, "minute");
setTime(43200 * hours, "hour");

function setTime(left, hand) {
	$(".clock__" + hand).css("animation-delay", "" + left * -1 + "s");
}

function getSecondsToday() {
	var now = getEventDate(new Date(), parseFloat($('meta[name=timezone]').attr('content'))*60);
	var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	var diff = now - today;
	return Math.round(diff / 1000);
}

function getEventDate(d, eventTimezoneOffset) {
	var timeCorrection = d.getTimezoneOffset() + eventTimezoneOffset;
	d.setMinutes(d.getMinutes() + timeCorrection);
	return d;
}
